<template>
    <header>
        <div class="container">
           <div class="container_header-left">
             <div class="header_links">
               <router-link :to="{ name: 'workboard-view'}" class="header_logo"><img :src="logoInHeader"
                                                                                     alt="adsquiz site logo"></router-link>
             </div>
             <div  v-show="isAuthenticated && isLoaded" class="header_tabs">
               <div class="header_tabs-builder">
                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-layers h-4 w-4"><path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"></path><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"></path><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"></path></svg>
                 <span>Quiz Builder</span>
               </div>
               <div class="header_tabs-crm">
                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users h-4 w-4"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                 <span>CRM</span>
                 <svg class="header_tabs-crm_soon" data-v-9b7b4df2="" width="43" height="14" viewBox="0 0 43 14" fill="none" xmlns="http://www.w3.org/2000/svg"><rect data-v-9b7b4df2="" width="43" height="14" rx="7" fill="url(#paint0_linear_12367_101507)"></rect><path data-v-9b7b4df2="" d="M13.0285 10.135C12.5545 10.135 12.127 10.0525 11.746 9.8875C11.368 9.7225 11.056 9.487 10.81 9.181C10.567 8.872 10.4125 8.506 10.3465 8.083L11.4715 7.912C11.5675 8.296 11.764 8.593 12.061 8.803C12.361 9.013 12.706 9.118 13.096 9.118C13.327 9.118 13.5445 9.082 13.7485 9.01C13.9525 8.938 14.1175 8.833 14.2435 8.695C14.3725 8.557 14.437 8.3875 14.437 8.1865C14.437 8.0965 14.422 8.014 14.392 7.939C14.362 7.861 14.317 7.792 14.257 7.732C14.2 7.672 14.125 7.618 14.032 7.57C13.942 7.519 13.837 7.4755 13.717 7.4395L12.043 6.9445C11.899 6.9025 11.743 6.847 11.575 6.778C11.41 6.706 11.2525 6.6085 11.1025 6.4855C10.9555 6.3595 10.834 6.2005 10.738 6.0085C10.645 5.8135 10.5985 5.5735 10.5985 5.2885C10.5985 4.8715 10.7035 4.522 10.9135 4.24C11.1265 3.955 11.4115 3.742 11.7685 3.601C12.1285 3.46 12.5275 3.391 12.9655 3.394C13.4095 3.397 13.8055 3.4735 14.1535 3.6235C14.5015 3.7705 14.7925 3.985 15.0265 4.267C15.2605 4.549 15.4255 4.8895 15.5215 5.2885L14.356 5.491C14.308 5.263 14.215 5.0695 14.077 4.9105C13.942 4.7485 13.7755 4.6255 13.5775 4.5415C13.3825 4.4575 13.174 4.4125 12.952 4.4065C12.736 4.4035 12.535 4.4365 12.349 4.5055C12.166 4.5715 12.0175 4.6675 11.9035 4.7935C11.7925 4.9195 11.737 5.0665 11.737 5.2345C11.737 5.3935 11.785 5.524 11.881 5.626C11.977 5.725 12.0955 5.8045 12.2365 5.8645C12.3805 5.9215 12.526 5.9695 12.673 6.0085L13.834 6.3325C13.993 6.3745 14.1715 6.4315 14.3695 6.5035C14.5675 6.5755 14.758 6.676 14.941 6.805C15.124 6.934 15.274 7.1035 15.391 7.3135C15.511 7.5235 15.571 7.7905 15.571 8.1145C15.571 8.4505 15.5005 8.746 15.3595 9.001C15.2215 9.253 15.034 9.463 14.797 9.631C14.56 9.799 14.2885 9.925 13.9825 10.009C13.6795 10.093 13.3615 10.135 13.0285 10.135ZM18.6915 10.135C18.2055 10.135 17.781 10.0255 17.418 9.8065C17.055 9.5875 16.773 9.286 16.572 8.902C16.374 8.515 16.275 8.071 16.275 7.57C16.275 7.06 16.377 6.613 16.581 6.229C16.785 5.845 17.0685 5.545 17.4315 5.329C17.7945 5.113 18.2145 5.005 18.6915 5.005C19.1805 5.005 19.6065 5.1145 19.9695 5.3335C20.3325 5.5525 20.6145 5.8555 20.8155 6.2425C21.0165 6.6265 21.117 7.069 21.117 7.57C21.117 8.074 21.015 8.5195 20.811 8.9065C20.61 9.2905 20.328 9.592 19.965 9.811C19.602 10.027 19.1775 10.135 18.6915 10.135ZM18.6915 9.118C19.1235 9.118 19.4445 8.974 19.6545 8.686C19.8645 8.398 19.9695 8.026 19.9695 7.57C19.9695 7.099 19.863 6.724 19.65 6.445C19.437 6.163 19.1175 6.022 18.6915 6.022C18.4005 6.022 18.1605 6.088 17.9715 6.22C17.7855 6.349 17.6475 6.5305 17.5575 6.7645C17.4675 6.9955 17.4225 7.264 17.4225 7.57C17.4225 8.041 17.529 8.4175 17.742 8.6995C17.958 8.9785 18.2745 9.118 18.6915 9.118ZM24.255 10.135C23.769 10.135 23.3445 10.0255 22.9815 9.8065C22.6185 9.5875 22.3365 9.286 22.1355 8.902C21.9375 8.515 21.8385 8.071 21.8385 7.57C21.8385 7.06 21.9405 6.613 22.1445 6.229C22.3485 5.845 22.632 5.545 22.995 5.329C23.358 5.113 23.778 5.005 24.255 5.005C24.744 5.005 25.17 5.1145 25.533 5.3335C25.896 5.5525 26.178 5.8555 26.379 6.2425C26.58 6.6265 26.6805 7.069 26.6805 7.57C26.6805 8.074 26.5785 8.5195 26.3745 8.9065C26.1735 9.2905 25.8915 9.592 25.5285 9.811C25.1655 10.027 24.741 10.135 24.255 10.135ZM24.255 9.118C24.687 9.118 25.008 8.974 25.218 8.686C25.428 8.398 25.533 8.026 25.533 7.57C25.533 7.099 25.4265 6.724 25.2135 6.445C25.0005 6.163 24.681 6.022 24.255 6.022C23.964 6.022 23.724 6.088 23.535 6.22C23.349 6.349 23.211 6.5305 23.121 6.7645C23.031 6.9955 22.986 7.264 22.986 7.57C22.986 8.041 23.0925 8.4175 23.3055 8.6995C23.5215 8.9785 23.838 9.118 24.255 9.118ZM31.0335 10V7.66C31.0335 7.507 31.023 7.3375 31.002 7.1515C30.981 6.9655 30.9315 6.787 30.8535 6.616C30.7785 6.442 30.6645 6.2995 30.5115 6.1885C30.3615 6.0775 30.1575 6.022 29.8995 6.022C29.7615 6.022 29.625 6.0445 29.49 6.0895C29.355 6.1345 29.232 6.2125 29.121 6.3235C29.013 6.4315 28.926 6.5815 28.86 6.7735C28.794 6.9625 28.761 7.2055 28.761 7.5025L28.1175 7.228C28.1175 6.814 28.197 6.439 28.356 6.103C28.518 5.767 28.755 5.5 29.067 5.302C29.379 5.101 29.763 5.0005 30.219 5.0005C30.579 5.0005 30.876 5.0605 31.11 5.1805C31.344 5.3005 31.53 5.4535 31.668 5.6395C31.806 5.8255 31.908 6.0235 31.974 6.2335C32.04 6.4435 32.082 6.643 32.1 6.832C32.121 7.018 32.1315 7.1695 32.1315 7.2865V10H31.0335ZM27.663 10V5.14H28.6305V6.6475H28.761V10H27.663Z" fill="white"></path><defs data-v-9b7b4df2=""><linearGradient data-v-9b7b4df2="" id="paint0_linear_12367_101507" x1="0" y1="7" x2="43" y2="7" gradientUnits="userSpaceOnUse"><stop data-v-9b7b4df2="" stop-color="#00D2FF"></stop><stop data-v-9b7b4df2="" offset="1" stop-color="#3A7BD5"></stop></linearGradient></defs></svg>
               </div>
             </div>
           </div>
            <transition name="fade" mode="out-in">
                <div class="header_buttons">
<!--                    <template v-if="isAuthenticated">-->
<!--                        <span v-if="isLoaded" v-tooltip="{-->
<!--                                text: $t('leadsLeft'),-->
<!--                                theme: {-->
<!--                                    placement: 'bottom',-->
<!--                                },-->
<!--                            }" :class="['leads_left_counter', ledsCounterClassModificator, lemniscateClassCurrent]">-->
<!--                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"-->
<!--                                xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path-->
<!--                                    d="M15.24 4.76186C15.1272 4.66351 14.9877 4.6009 14.8393 4.58199C14.6908 4.56307 14.5401 4.58869 14.4062 4.65561L11.2681 6.21811L8.64812 1.86623C8.58077 1.75456 8.48571 1.66218 8.37216 1.59806C8.2586 1.53394 8.13041 1.50024 8 1.50024C7.86959 1.50024 7.74139 1.53394 7.62784 1.59806C7.51428 1.66218 7.41922 1.75456 7.35187 1.86623L4.73187 6.21998L1.595 4.65748C1.46146 4.59116 1.31131 4.56576 1.16339 4.58447C1.01547 4.60317 0.876369 4.66515 0.763543 4.76262C0.650717 4.86009 0.569193 4.98871 0.5292 5.13235C0.489208 5.27598 0.492529 5.42823 0.538747 5.56998L2.85125 12.655C2.8745 12.7262 2.91344 12.7912 2.96519 12.8453C3.01695 12.8994 3.0802 12.9412 3.15027 12.9676C3.22034 12.994 3.29545 13.0043 3.37004 12.9978C3.44463 12.9913 3.51681 12.9681 3.58125 12.93C3.59687 12.9206 5.195 12 8 12C10.805 12 12.4031 12.9206 12.4175 12.9294C12.482 12.9679 12.5543 12.9914 12.629 12.9981C12.7038 13.0049 12.7792 12.9947 12.8495 12.9683C12.9198 12.942 12.9832 12.9001 13.0352 12.8459C13.0871 12.7916 13.1261 12.7264 13.1494 12.655L15.4619 5.57186C15.5094 5.43006 15.5137 5.27733 15.4742 5.13309C15.4347 4.98885 15.3532 4.85963 15.24 4.76186ZM12.375 11.8019C11.625 11.4837 10.13 11 8 11C5.87 11 4.375 11.4837 3.625 11.8019L1.66937 5.81248L4.48625 7.21686C4.65675 7.30094 4.85256 7.31813 5.03511 7.26503C5.21765 7.21193 5.37369 7.0924 5.4725 6.92998L8 2.72873L10.5275 6.92873C10.6263 7.09099 10.7822 7.21042 10.9646 7.2635C11.147 7.31659 11.3427 7.29951 11.5131 7.21561L14.3306 5.81248L12.375 11.8019Z" />-->
<!--                            </svg>-->
<!--                            {{ availableLeadsCounter }}-->
<!--                        </span>-->
<!--                    </template>-->
                    <div v-if="!isAuthenticated && isLoaded" class="header_languages">
                        <LanguageSelector @change-locale="changeLocale" />
                    </div>
                    <template v-if="isAuthenticated && isLoaded">
                      <PlanUsagePopover v-slot="{ popoverId }">
                        <SwitchProButton
                            :textButton="switchProButtonViewModel.text"
                            :isUnlimited="switchProButtonViewModel.isUnlimited"
                            :availableLeadsCounter="switchProButtonViewModel.counter"
                            :aria-describedby="popoverId"
                            @click="goToTariffs()"
                        />
                      </PlanUsagePopover>
<!--                      <button v-if="curentActiveTarif.price == 0" class="header_upversion" @click="goToTariffs()">-->
<!--                            <img src="/img/icons/upversion-star.svg" alt=""> {{-->
<!--                            uprevisionButtonText}}</button>-->
<!--                        <button v-else class="header_upversion" @click="goToTariffs()"> <img-->
<!--                                src="/img/icons/upversion-star.svg" alt=""> {{ $t('getLeads')}}</button>-->

                      <div
                          class="header_profile-trigger"
                          role="button"
                          tabindex="0"
                          @click="toggleProfileModal"
                          @keyup.enter.prevent="toggleProfileModal"
                      >
                        <img
                            v-if="user.avatar"
                            :src="user.avatar"
                            alt="avatar"
                            class="header_profile-img"
                        />
                        <button v-else type="button" class="header_profile">
                          {{ userSymbol }}
                        </button>

                        <svg
                            class="header_profile-arrow"
                            :class="{ 'is-open': isProfileOpen }"
                            width="20" height="20" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                          <g clip-path="url(#clip0_12888_5372)">
                            <path d="M15.8346 7.5L10.0013 13.3333L4.16797 7.5"
                                  stroke="#3749C0" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_12888_5372">
                              <rect width="20" height="20" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>

                    </template>
                </div>
            </transition>
        </div>
    </header>
</template>

<script>
import LanguageSelector from '@/components/common/LanguageSelector.vue'
import {useUserStore} from "@/store/userStore";
// services
import usersServices from "@/services/users.service";
import usersService from "@/services/users.service";
import {fragmentUserForHeader} from "@/graphql/fragments/query/users.fragments";
import {fragmentUpdateUserLang} from "@/graphql/fragments/mutation/users.fragments";
import SwitchProButton from "@/components/ui/SwitchProButton.vue";
import PlanUsagePopover from "@/components/tariff/PlanUsagePopover.vue";
import {calculateRemainLeads} from "@/utils/calculateRemainLeads";
import {getCurrentTariff, isDisplayUnlimitedTariff} from "@/utils/leadConsumption";
import {formatLeadsCount} from "@/utils/formatLeadsCount";

export default {
  name: 'header-vue',
  components: {
    SwitchProButton,
    PlanUsagePopover,
    LanguageSelector,
  },
  props: {
    isAuthenticated: Boolean,
    isProfileOpen: { type: Boolean, default: false },
  },
  data() {
    return {
        baseBackendUrl: process.env.VUE_APP_BASE_URL,
        lang: "UA",
        userStore: useUserStore(),
        // opacityElement: 0,
        userInfo: {
            id: "17",
                email: "vasyayaya@mail.ru",
                name: "Jhonathan",
                role: "user",
                profile: "agency",
                tarifs: [{
                    id: "1",
                    name: "Free.",
                    price: 10,
                    usedLeads: 100,
                    maxLeadsCount: 100,
                    maxQuizzesCount: 0,
                    created_at: 1670528835,
                    is_active: true,
                    start_at: 1670528835,
                    end_at: 1670528835,
                }],
                tarif: {},
                period_starts_at: null,
                payments: [{
                    id: "6",
                    payment: "PT172022212_1670528631",
                    amount: 1,
                    created_at: 1670528835,
                    payment_system: "Stripe",
                    data: "{\"cardType\": \"Visa\"}",
                }],
                created_at: 1665096088,
                quizCounter: 0,
                leadCounter: 0,
                is_blocked: false,
                bonuses: [{
                    start: 1665096088,
                    end: 1665096088,
                    leads_count: 0,
                    used: 0,
                    coupon: '',
                    created_at: 1665096088,
                    updated_at: 1665096088,
                }],
        },
        isMobile: false,
        isLoaded: false,
    }
  },
  computed: {
    user() {
      return this.userStore.userData || {};
    },
    userSymbol() {
        return this.userInfo.name.slice(0, 1)
    },
    remainingLeadsInfo() {
      return calculateRemainLeads(this.userInfo);
    },

    switchProButtonViewModel() {
      const isUnlimited = this.remainingLeadsInfo?.status === 'unlimited'
        || isDisplayUnlimitedTariff(getCurrentTariff(this.userInfo?.tarifs));

      if (isUnlimited) {
        return {
          isUnlimited: true,
          counter: '',
          text: this.$t('billingInfinity') || '',
        };
      }

      const remainingCount = Number(this.remainingLeadsInfo?.count ?? 0);

      return {
        isUnlimited: false,
        counter: formatLeadsCount(remainingCount, this.localeForIntl),
        text: remainingCount <= 0 ? this.$t('getLeads') : this.$t('billingYourTariffShortForm'),
      };
    },
    logoInHeader() {
        return this.isMobile ? "/img/icons/adsquiz-logo-mobile.svg" : "/img/icons/adsquiz-logo.svg";
    },
    localeForIntl() {
      const raw = String(this.$i18n?.locale || 'en').toLowerCase();
      if (raw === 'ua') return 'uk';
      return raw;
    },
  },
  methods: {
    goToTariffs() {
        this.$emit('go-to-tariffs', true);
    },
    toggleProfileModal() {
        this.$emit('togle-profile-modal');
    },
    refreshUserInfo() {
        this.$emit('refresh-user-info', this.userInfo);
    },
    changeLocale(locale) {
      this.$i18n.locale = locale
      localStorage.setItem('locale_lang', locale)
      this.mountedLang(this.$i18n.locale)
      if (this.isAuthenticated) {
        this.updateUserLang(this.$i18n.locale)
      }
    },
    changeLocaleAfterLogin(interface_lang) {
        this.$i18n.locale = interface_lang
    },
    async updateUserLang(locale) {
      try {
        await usersServices.updateInterfaceLang({id: this.userInfo.id, interface_lang: locale}, fragmentUpdateUserLang)
      } catch(error) {
        this.$notify({
          title: 'Помилка в оновлені даних: "' + this.userInfo.email,
          type: 'error'
        });
        console.log(error);
      }
    },
    async giveProfileInfo() {
        try {
          this.userInfo = await usersService.getUserData({
            fragment: fragmentUserForHeader,
            variables: { current: true },
          });
          this.refreshUserInfo()
          // this.opacityElement = 1
          let locale_lang = this.userInfo.interface_lang ? this.userInfo.interface_lang.toUpperCase() : 'EN';
          const availableLocales = this.$i18n.availableLocales.map(locale => locale.toUpperCase());

          if (availableLocales.includes(locale_lang)) {
            this.changeLocaleAfterLogin(locale_lang);
          } else {
            this.changeLocaleAfterLogin('EN');
          }
          this.mountedLang(this.$i18n.locale)
          this.isLoaded = true
        } catch(error){
          console.log(error);
          this.errorAuth(error.response.status)
        }
    },
    mountedLang(interfaceLang) {
        var htmlElement = document.getElementsByTagName('html')[0]
        htmlElement.setAttribute('lang', interfaceLang);
    },
  },
  created() {
    this.isMobile = window.innerWidth <= 680;
  },
  mounted() {
    if (this.isAuthenticated) {
       this.giveProfileInfo();
    } else {
        this.isLoaded = true;
    }

  },
  watch: {

  }
};
</script>

<style scoped>
header {
  width: 100%;
  padding: 8px 28px;
  height: 64px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 100;
  background: var(--color-main-white);
  border-bottom: 1px solid var(--color-main-gray);
}

header > .container {
  max-width: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;
}

.header_section {
  padding: 30px;
}

.container_header-left {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  min-width: 0;
  flex: 1 1 auto;
}

.header_links {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.header_logo {
  margin-right: 20px;
  flex-shrink: 0;
}

.header_logo img {
  width: auto;
  height: auto;
  max-width: none;
  min-width: auto;
  object-fit: contain;
}

.header_to-site {
  color: #000;
  font-size: 40px;
  margin-right: 40px;
  font-weight: 900;
  line-height: 20px;
}

.header_to-site:hover {
  transition-duration: 0.3s;
  border-radius: 100px 20px 20px 100px;
  animation: backbtnmove 0.4s cubic-bezier(0, -0.28, 0.62, 1.21) infinite alternate;
}

.header_in-ukraine {
  font-size: 14px;
  color: #000;
  font-weight: 700;
}

.header_buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  flex: 0 1 auto;
  min-width: 0;
}

.leads_left_counter {
  padding: 6px 16px;
  border-radius: 40px;
  gap: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 6px;
}

.header_languages {
  display: flex;
}

.header_languages input {
  border: none;
  background: none;
  width: 32px;
  color: #000;
  font-weight: 300;
}

.header_languages input:hover,
.header_languages input:active,
.header_languages input:focus {
  font-weight: 800;
  outline: none;
  box-shadow: none !important;
}

.header_languages input.active {
  font-weight: 800;
}

.header_upversion {
  background: var(--color-main-blue);
  border: 1px solid var(--color-main-blue);
  color: var(--color-main-white);
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  font-weight: 700;
  height: 40px;
}

.header_upversion img {
  height: 12px;
  width: 12px;
  margin-right: 8px;
}

.header_upversion:hover {
  cursor: pointer;
}

.header_profile {
  border: 1px solid var(--color-main-light-blue);
  background: var(--color-main-light-blue);
  background-repeat: no-repeat;
  background-size: cover;
  color: var(--color-main-blue);
  border-radius: 100px;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.header_profile-img {
  border: 1px solid var(--color-main-light-blue);
  cursor: pointer;
  object-fit: cover;
  border-radius: 100px;
  width: 32px;
  height: 32px;
  display: block;
}

.header_profile:hover,
.header_profile-img:hover {
  transform: scale(1.05);
}

.header_profile-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border: 1px solid #EFF1FF;
  border-radius: 25px;
  cursor: pointer;
  user-select: none;
  flex: 0 0 auto;
  transition:
      background-color .2s ease,
      border-color .2s ease;
}

.header_profile-trigger:hover {
  background-color: #EFF1FF;
  border-color: #3749C0;
}

.header_profile-arrow {
  display: block;
  transition: transform 160ms ease;
  transform-origin: center;
}

.header_profile-arrow.is-open {
  transform: rotate(180deg);
}

.header_tabs {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 0 1 auto;
}

.header_tabs-builder {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  border-radius: 12px;
  align-items: center;
  background: #ecefff;
  outline: 1px solid var(--color-main-blue);
  color: var(--color-main-blue);
  padding: 5px 10px;
  height: 36px;
  cursor: pointer;
  max-width: 120px;
  justify-content: center;
  width: 120px;
  flex: 0 0 auto;
}

.header_tabs-crm {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  border-radius: 12px;
  align-items: center;
  background: #F5F5F5;
  color: var(--color-main-black);
  padding: 5px 10px;
  height: 36px;
  cursor: not-allowed;
  max-width: 80px;
  justify-content: center;
  width: 80px;
  position: relative;
  flex: 0 0 auto;
  transition:
      background-color .2s ease,
      color .2s ease,
      outline-color .2s ease,
      transform .2s ease,
      width .2s ease,
      padding .2s ease;
}

.header_tabs-crm svg:not(.header_tabs-crm_soon) {
  transition: color .2s ease, transform .2s ease;
}

.header_tabs-crm:hover {
  background: #ecefff;
  outline: 1px solid var(--color-main-blue);
  color: var(--color-main-blue);
}

.header_tabs-crm:hover svg:not(.header_tabs-crm_soon) {
  transform: scale(1.05);
}

.header_tabs-builder svg,
.header_tabs-crm svg:not(.header_tabs-crm_soon) {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

.header_tabs-builder span,
.header_tabs-crm span {
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  white-space: nowrap;
}

.header_tabs-crm_soon {
  width: 43px;
  position: absolute;
  top: -5px;
  right: -10px;
}

@media screen and (max-width: 900px) {
  header {
    padding: 8px 16px;
  }

  header > .container {
    gap: 12px;
  }

  .container_header-left {
    gap: 20px;
  }

  .header_buttons {
    gap: 14px;
  }

  .header_in-ukraine {
    display: none;
  }
}

@media screen and (max-width: 760px) {
  .container_header-left {
    gap: 12px;
  }

  .header_tabs {
    gap: 8px;
  }

  .header_tabs-builder,
  .header_tabs-crm {
    width: 44px;
    max-width: 44px;
    min-width: 44px;
    padding: 5px 8px;
    gap: 0;
  }

  .header_tabs-builder span,
  .header_tabs-crm span {
    display: none;
  }

  .header_tabs-crm_soon {
    right: -8px;
  }

  .header_buttons {
    gap: 10px;
  }

  .header_buttons :deep(.switch-pro-button__text) {
    display: none;
  }
}

@media screen and (max-width: 680px) {
  header {
    height: 64px;
    padding: 8px 12px;
  }

  header > .container {
    flex-wrap: nowrap;
  }

  .header_profile,
  .header_profile-img {
    height: 32px;
    width: 32px;
  }

  .header_profile-trigger {
    padding: 6px 8px;
    gap: 6px;
  }

  .leads_left_counter {
    padding: 6px 8px;
  }

  .header_upversion {
    height: auto;
    padding: 6px 8px;
  }

  .selected-language {
    padding: 6px 8px;
  }
}

@media screen and (max-width: 520px) {
  header {
    padding: 8px;
  }

  header > .container {
    gap: 8px;
  }

  .container_header-left {
    gap: 8px;
  }

  .header_tabs {
    gap: 6px;
  }

  .header_tabs-builder,
  .header_tabs-crm {
    width: 40px;
    max-width: 40px;
    min-width: 40px;
    height: 34px;
    padding: 5px 7px;
  }

  .header_buttons {
    gap: 6px;
  }

  .leads_left_counter {
    display: none;
  }

  .header_profile-trigger {
    padding: 5px 7px;
  }

  .header_profile-arrow {
    width: 18px;
    height: 18px;
  }
}

@media screen and (max-width: 390px) {
  .header_logo img {
    max-width: 40px;
  }

  .header_tabs-builder,
  .header_tabs-crm {
    width: 36px;
    max-width: 36px;
    min-width: 36px;
    height: 32px;
    padding: 5px;
  }

  .header_tabs-builder svg,
  .header_tabs-crm svg:not(.header_tabs-crm_soon) {
    width: 15px;
    height: 15px;
  }

  .header_buttons :deep(.switch-pro-button__counter) {
    font-size: 12px;
  }
}
</style>
